export default {
    setUser(state, { user, token }) {
      state.user = user;
      state.token = token;
  },logout(state) {
    state.token = null;
    localStorage.removeItem("token");
  }
};
